import { AlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { EventProperties } from 'usage-tracker-core/common/types';

import { LocalisedConnectedStatus } from '../../../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService';
import { getNoStatusesOptions } from './getNoStatusesOptions';
import { getSingleAccountOptions } from './getSingleAccountOptions';
import { getMultipleAccountOptions } from './getMultipleAccountsOptions';
import { IntegrationProductType } from '../../../types/integrationProductType';

type TGetOptionsArgs = {
  accountStatusesList?: LocalisedConnectedStatus[];
  alertStore?: AlertStore;
  loading?: boolean;
  onAuthSucceeded?: () => void;
  productType?: IntegrationProductType;
  setPopoverOpen: (open?: boolean) => void;
  showInstalledStatus?: boolean;
  tracker?: (event: EventProperties) => void;
};

export const getOptions = ({
  accountStatusesList = [],
  alertStore,
  loading,
  showInstalledStatus,
  onAuthSucceeded = () => {},
  productType,
  setPopoverOpen,
  tracker,
}: TGetOptionsArgs) => {
  if (accountStatusesList?.length === 0) {
    return getNoStatusesOptions({ showInstalledStatus, productType });
  }

  if (accountStatusesList.length === 1) {
    return getSingleAccountOptions({
      alertStore,
      loading,
      onAuthSucceeded,
      setPopoverOpen,
      statusData: accountStatusesList[0],
      tracker,
    });
  }

  return getMultipleAccountOptions({
    accountStatusesList,
    tracker,
  });
};
